export default __webpack_public_path__ + "static/media/small_item_bg.de0ca105.png";